module.exports = {
	"id": "abt513",
	"enabled": true,
	"type": "standard",
	"split": 2,
	"dateRange": [
		{
			"start": "2016-05-06T09:00:00-05:00",
			"end": "2016-05-13T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-05-27T23:59:59-05:00",
	"evar": {
		"number": 66,
		"qa": 68,
		"name": "fulfillment_incentives",
		"skip": true
	},
	"pageCriteria": {
		"pageType": [
			"checkout"
		]
	},
	"deviceSize": [
		"s",
		"m",
		"l"
	],
	"buckets": [
		"19",
		"20"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt513/config.json
 ** module id = 33
 ** module chunks = 2
 **/